export const sectionData = {
  organization: [
    {
      title: "Company Details",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Discloser Details",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/4",
          label: "Type of alignment being reported for this financial metric",
          type: "select",
          options: [
            {
              key: "Alignment with a sustainable finance taxonomy",
              value: "Alignment with a sustainable finance taxonomy",
              _id: "678114c77e926d878a7ae4ae",
            },
            {
              key: "Alignment with our climate transition plan",
              value: "Alignment with our climate transition plan",
              _id: "678114c77e926d878a7ae4af",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4ad",
        },
        {
          questionId: "3/18/5/5",
          label: "Taxonomy under which information is being reported*",
          type: "select",
          options: [
            {
              key: "EU Taxonomy for Sustainable Activities",
              value: "EU Taxonomy for Sustainable Activities",
              _id: "678114c77e926d878a7ae4b1",
            },
            {
              key: "Other, please specify",
              value: "Other, please specify",
              _id: "678114c77e926d878a7ae4b2",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b0",
        },
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
        {
          questionId: "3/18/5/7",
          label:
            "Percentage share of selected financial metric aligned in the reporting year (%)",
          type: "number",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b8",
        },
      ],
    },
    {
      title: "Nature of Work",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Customer Detail",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Employees / Workers",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Reporting Boundaries",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  environment: [
    {
      title: "Environmental Policies",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Energy Usage",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Water Consumption",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Waste Management",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Biodiversity",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  social: [
    {
      title: "Community Engagement",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Labor Practices",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Diversity & Inclusion",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Health & Safety",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Human Rights",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
  governance: [
    {
      title: "Ethical Standards",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Board Structure",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Risk Management",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Compliance",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
    {
      title: "Transparency",
      totalQuestions: 20,
      questions: [
        {
          questionId: "3/18/5/5",
          label: "Objective under which alignment is being reported*",
          type: "select",
          options: [
            {
              key: "Climate change mitigation",
              value: "Climate change mitigation",
              _id: "678114c77e926d878a7ae4b4",
            },
            {
              key: "Climate change adaptation",
              value: "Climate change adaptation",
              _id: "678114c77e926d878a7ae4b5",
            },
            {
              key: "Total across all objectives",
              value: "Total across all objectives",
              _id: "678114c77e926d878a7ae4b6",
            },
          ],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b3",
        },
        {
          questionId: "3/18/5/6",
          label:
            "Amount of selected financial metric that is aligned in the reporting year (unit currency as selected in C0.4)",
          type: "text",
          placeholder: "1234",
          options: [],
          dynamicOptions: null,
          condition: null,
          _id: "678114c77e926d878a7ae4b7",
        },
      ],
    },
  ],
};
